$(document).ready(function() {
	console.log('jquery load!');
});
